import React from "react";
import "./Pages.css";

const FAQ: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Frequently Asked Questions</h1>

      <h2>What services does The Destination Dreams Travel offer?</h2>
      <p>
        We arrange flight tickets, hotel reservations, holiday packages, car hire
        and travel insurance for individuals and groups.
      </p>

      <h2>How do I make a booking?</h2>
      <p>
        Browse our flights, hotels, packages and tours, then submit an enquiry or
        contact our team. We confirm availability and share a payment link or
        instructions to complete your booking.
      </p>

      <h2>Is online payment secure?</h2>
      <p>
        Yes. Payments are processed through the <strong>Bank Muscat</strong> secure
        payment gateway over an encrypted (HTTPS) connection. We do not store your
        full card details on our website.
      </p>

      <h2>Which payment methods are accepted?</h2>
      <p>
        Major debit/credit cards supported by the Bank Muscat gateway. All charges
        are in Omani Rial (OMR).
      </p>

      <h2>When do I receive my ticket/voucher?</h2>
      <p>
        After a confirmed payment, your e-ticket/voucher and booking confirmation are
        emailed to you — usually within 24 hours (up to 48–72 hours where supplier
        confirmation is required). See our Delivery Policy for details.
      </p>

      <h2>Can I cancel or change my booking, and how do refunds work?</h2>
      <p>
        Yes, subject to the airline/hotel/supplier rules. Eligible refunds are
        returned to your original payment method, typically within 7–14 business
        days after the supplier confirms the cancellation. See our Cancellation,
        Refund and Return Policy.
      </p>

      <h2>How do I contact customer service?</h2>
      <ul>
        <li>Phone: +968 95987986</li>
        <li>Email: team@dreamstriphub.com</li>
        <li>Location: Amirat, Muscat, Oman</li>
      </ul>
    </div>
  );
};

export default FAQ;
